export default {
    lineRegisterCode: 'Line Register Code',
    code: 'Code',
    copy: 'Copy',
    copied: 'Copied',
    create: 'Create',
    cancel: 'Cancel'
}
